<template>
  <va-edit-layout>
    <categories-form :id="id" :title="title" :item="item"></categories-form>
  </va-edit-layout>
</template>

<script>
export default {
  props: ["id", "title", "item"],
};
</script>
